if (!window.pwScriptsCargado) {
  window.pwScriptsCargado = true;

  /* Intensidad de los efectos en MOVIL (1 = la original, 1.03 = +3 %).
     Es el unico numero que hay que tocar para subirlos o bajarlos: lo
     leen el pack 3D del Hero (initHeroPremium) y pw-fx-movil-8.js.
     Rolando pide los ajustes en porcentaje: +2 % -> 1.05, -1 % -> 1.02. */
  window.PW_MOVIL_INTENSIDAD = 1.03;

  /* Arranque a prueba de orden de carga: se intenta al ejecutar el script,
     al terminar de parsear el DOM y al terminar de cargar la pagina.
     Cada elemento se marca para no inicializarse dos veces. */
  function pwArrancar() {
    initReveals();
    initCountUp();
    initGallery();
    initVariantes();
    initTilt();
    initHeroPremium();
    initEscena3D();
    initTactil();
    initEscritorio();
  }
  pwArrancar();
  document.addEventListener('DOMContentLoaded', pwArrancar);
  window.addEventListener('load', pwArrancar);

  /* "Reducir movimiento" del sistema: solo se respeta en escritorio.
     En movil los efectos van siempre (decision de Rolando, 02/10). */
  function pwReducido() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
      window.matchMedia('(hover: hover)').matches;
  }

  function nuevo(el, marca) {
    if (el.dataset[marca]) return false;
    el.dataset[marca] = '1';
    return true;
  }

  /* En movil no hay raton, asi que el eje lo da el scroll: la posicion
     del elemento en la pantalla inclina la escena. Devuelve -1 cuando el
     bloque esta arriba del todo y 1 cuando esta abajo del todo. */
  function pwPorScroll(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || 1;
    return Math.max(-1, Math.min(1, (0.5 - (r.top + r.height / 2) / vh) * 1.6));
  }

  /* En un dispositivo sin raton, @media (hover: hover) no se cumple y toda
     la capa de efectos del tema queda muerta. Aqui se marca html.pw-touch
     y se cargan el CSS y el JS de la version movil. El escritorio se sale
     en la primera linea: no marca nada y no descarga nada.

     Dos trampas del CDN de Shopify, aprendidas a base de golpes:
     1) No reutilizar el ?v=... de pw-styles.css. Ese hash pertenece a ese
        archivo; si se reutiliza, devuelve la version congelada en ese hash.
     2) Sin ?v=..., el CDN cachea el archivo por nombre. Para publicar un
        cambio hay que CAMBIAR EL NOMBRE del archivo y actualizarlo aqui.
        Por eso los nombres llevan sufijo numerico. */
  function initTactil() {
    if (window.matchMedia('(hover: hover)').matches) return;
    var raiz = document.documentElement;
    if (!raiz.classList.contains('pw-touch')) raiz.classList.add('pw-touch');
    if (document.getElementById('pw-movil-css')) return;
    var base = null;
    var enlaces = document.querySelectorAll('link[rel="stylesheet"]');
    for (var i = 0; i < enlaces.length; i++) {
      if (enlaces[i].href.indexOf('pw-styles.css') !== -1) { base = enlaces[i].href; break; }
    }
    if (!base) return;
    var carpeta = base.split('?')[0].replace('pw-styles.css', '');
    var l = document.createElement('link');
    l.id = 'pw-movil-css';
    l.rel = 'stylesheet';
    l.href = carpeta + 'pw-movil-10.css';
    document.head.appendChild(l);
    var s = document.createElement('script');
    s.id = 'pw-movil-js';
    s.src = carpeta + 'pw-fx-movil-8.js';
    s.defer = true;
    document.head.appendChild(s);
  }

  /* Gemelo de initTactil() para el otro lado. En escritorio los efectos
     vivian solo en :hover; estos dos archivos los encienden con el scroll
     y el raton suma encima. Sufijo numerico: el CDN cachea por nombre. */
  function initEscritorio() {
    if (!window.matchMedia('(hover: hover)').matches) return;
    var raiz = document.documentElement;
    if (!raiz.classList.contains('pw-desk-fx')) raiz.classList.add('pw-desk-fx');
    if (document.getElementById('pw-desk-css')) return;
    var base = null;
    var enlaces = document.querySelectorAll('link[rel="stylesheet"]');
    for (var i = 0; i < enlaces.length; i++) {
      if (enlaces[i].href.indexOf('pw-styles.css') !== -1) { base = enlaces[i].href; break; }
    }
    if (!base) return;
    var carpeta = base.split('?')[0].replace('pw-styles.css', '');
    var l = document.createElement('link');
    l.id = 'pw-desk-css';
    l.rel = 'stylesheet';
    l.href = carpeta + 'pw-fx-escritorio-5.css';
    document.head.appendChild(l);
    var s = document.createElement('script');
    s.id = 'pw-desk-js';
    s.src = carpeta + 'pw-fx-escritorio-3.js';
    s.defer = true;
    document.head.appendChild(s);
  }

  function initReveals() {
    var els = document.querySelectorAll('.pw-reveal');
    if (!els.length) return;
    var reducido = pwReducido();
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pw-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) {
      if (!nuevo(el, 'pwRev')) return;
      if (reducido) { el.classList.add('pw-visible'); return; }
      observer.observe(el);
      /* Red de seguridad: si por lo que sea el observador no dispara,
         el contenido nunca se queda invisible. */
      setTimeout(function () { el.classList.add('pw-visible'); }, 2500);
    });
  }

  function initCountUp() {
    var els = document.querySelectorAll('.pw-count');
    if (!els.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);
        var target = parseFloat(el.dataset.target || '0');
        var suffix = el.dataset.suffix || '';
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / 1200, 1);
          el.textContent = Math.floor(p * target) + suffix;
          if (p < 1) requestAnimationFrame(step); else el.textContent = target + suffix;
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { if (nuevo(el, 'pwCount')) observer.observe(el); });
  }

  function initGallery() {
    var thumbs = document.querySelectorAll('.pw-thumb');
    var main = document.getElementById('pw-main-image');
    if (!thumbs.length || !main) return;
    thumbs.forEach(function (thumb) {
      if (!nuevo(thumb, 'pwThumb')) return;
      thumb.addEventListener('click', function () {
        main.src = thumb.dataset.full;
        thumbs.forEach(function (t) { t.classList.remove('pw-thumb--active'); });
        thumb.classList.add('pw-thumb--active');
      });
    });
  }

  function initVariantes() {
    var select = document.querySelector('[data-pw-variant-select]');
    if (!select || !nuevo(select, 'pwVar')) return;
    var dataEl = document.querySelector('[data-pw-variants-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInputs = document.querySelectorAll('[data-pw-variant-id]');
    var priceEl = document.querySelector('[data-pw-price]');
    var addBtn = document.querySelector('[data-pw-add-btn]');
    var buyBtn = document.querySelector('[data-pw-buy-btn]');
    select.addEventListener('change', function () {
      var v = variants.find(function (x) { return x.id.toString() === select.value; });
      if (!v) return;
      idInputs.forEach(function (i) { i.value = v.id; });
      if (priceEl) priceEl.textContent = v.price_formatted;
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? addBtn.dataset.labelAvailable : addBtn.dataset.labelSoldOut; }
      if (buyBtn) { buyBtn.disabled = !v.available; buyBtn.href = '/cart/' + v.id + ':1'; }
    });
  }

  function initTilt() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(hover: hover)').matches) return;
    document.querySelectorAll('.pw-tilt').forEach(function (el) {
      if (!nuevo(el, 'pwTilt')) return;
      var maxTilt = parseFloat(el.dataset.tilt || '10');
      var scale = parseFloat(el.dataset.tiltScale || '1.02');
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        el.style.transform = 'perspective(800px) rotateX(' + ((0.5 - y) * maxTilt * 2) + 'deg) rotateY(' + ((x - 0.5) * maxTilt * 2) + 'deg) scale(' + scale + ')';
      });
      el.addEventListener('mouseleave', function () {
        el.style.transform = 'perspective(800px) rotateX(0deg) rotateY(0deg) scale(1)';
      });
    });
  }

  function initHeroPremium() {
    if (pwReducido()) return;
    document.querySelectorAll('[data-hero-stage]').forEach(function (stage) {
      var card = stage.querySelector('.pw-hero-card');
      if (!card || !nuevo(stage, 'pwHero')) return;
      var light = stage.querySelector('.pw-hero-light');
      var glass = stage.querySelector('.pw-hero-glass');
      var MAX = parseFloat(stage.getAttribute('data-rot')) || 16;
      var idleOn = stage.getAttribute('data-idle') === '1';
      var hoverCapable = window.matchMedia('(hover: hover)').matches;
      if (!hoverCapable) MAX *= (window.PW_MOVIL_INTENSIDAD || 1);
      var mx = 0, my = 0, cx = 0, cy = 0, tG = 0, cG = 0, gx = 50, gy = 50, hover = false, ease = 0.09;
      (function render() {
        /* Movil: el scroll inclina el pack y mueve la luz. */
        if (!hoverCapable) {
          my = pwPorScroll(stage); mx = 0;
          gx = 50; gy = 50 + my * 30;
          tG = 0.75; hover = false;
        }
        var t = Date.now() * 0.001;
        var iX = (!hover && idleOn) ? Math.sin(t * 1.2) * 1.4 : 0;
        var iY = (!hover && idleOn) ? Math.cos(t * 0.8) * 1.4 : 0;
        var iZ = (!hover && idleOn) ? Math.sin(t * 1.5) * 8 : 0;
        cx += (mx - cx) * ease; cy += (my - cy) * ease; cG += (tG - cG) * ease;
        card.style.transform = 'rotateX(' + ((-cy * MAX) + iX) + 'deg) rotateY(' + ((cx * MAX) + iY) + 'deg) translateZ(' + iZ + 'px)';
        card.style.filter = 'drop-shadow(' + (-cx * MAX * 0.9) + 'px ' + (Math.abs(cy) * MAX * 0.9 + 18) + 'px 50px rgba(21,10,36,.26))';
        if (light) {
          light.style.opacity = cG * 0.8;
          light.style.background = 'radial-gradient(circle at ' + gx + '% ' + gy + '%, rgba(255,255,255,.72), rgba(255,255,255,0) 45%)';
        }
        if (glass) {
          glass.style.opacity = cG * 0.85;
          glass.style.transform = 'rotate(8deg) translateX(' + (-40 + gx * 1.9) + 'px)';
        }
        requestAnimationFrame(render);
      })();
      if (hoverCapable) {
        stage.addEventListener('mousemove', function (e) {
          var r = stage.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
          mx = (px - 0.5) * 2; my = (py - 0.5) * 2; gx = px * 100; gy = py * 100; tG = 1; hover = true;
        });
        stage.addEventListener('mouseleave', function () { mx = 0; my = 0; tG = 0; hover = false; });
      }
    });
  }

  /* Escena 3D compartida: imagen y lettering giran juntos como un solo objeto.
     Cada capa esta a distinta profundidad -> paralaje real al girar, y la luz
     de volumen se desplaza en sentido contrario, como una luz fija en la sala.

     En MOVIL la escena NO rota: la mujer se queda recta y solo sube y brilla
     con el scroll. Ademas asi no hay bucle corriendo y se ahorra bateria. */
  function initEscena3D() {
    if (pwReducido()) return;
    document.querySelectorAll('[data-pw-scene]').forEach(function (esc) {
      var inner = esc.querySelector('.pw-scene__inner');
      if (!inner || !nuevo(esc, 'pwEscena')) return;
      var MAX = parseFloat(esc.getAttribute('data-rot')) || 10;
      var idleOn = esc.getAttribute('data-idle') === '1';
      var lx = parseFloat(esc.getAttribute('data-lx')) || 35;
      var ly = parseFloat(esc.getAttribute('data-ly')) || 30;
      var hoverCapable = window.matchMedia('(hover: hover)').matches;

      if (!hoverCapable) {
        inner.style.transform = 'none';
        esc.style.setProperty('--pw-vol-x', lx + '%');
        esc.style.setProperty('--pw-vol-y', ly + '%');
        return;
      }

      var mx = 0, my = 0, cx = 0, cy = 0, activo = false, ease = 0.08;
      (function frame() {
        var t = Date.now() * 0.001;
        var iY = (!activo && idleOn) ? Math.sin(t * 0.6) * 0.9 : 0;
        var iX = (!activo && idleOn) ? Math.cos(t * 0.45) * 0.6 : 0;
        cx += (mx - cx) * ease; cy += (my - cy) * ease;
        var rotY = cx * MAX + iY, rotX = -cy * MAX + iX;
        inner.style.transform = 'rotateX(' + rotX.toFixed(2) + 'deg) rotateY(' + rotY.toFixed(2) + 'deg)';
        esc.style.setProperty('--pw-vol-x', (lx - rotY * 1.8).toFixed(1) + '%');
        esc.style.setProperty('--pw-vol-y', (ly - rotX * 1.4).toFixed(1) + '%');
        requestAnimationFrame(frame);
      })();
      esc.addEventListener('mousemove', function (e) {
        var r = esc.getBoundingClientRect();
        mx = ((e.clientX - r.left) / r.width - 0.5) * 2;
        my = ((e.clientY - r.top) / r.height - 0.5) * 2;
        activo = true;
      });
      esc.addEventListener('mouseleave', function () { mx = 0; my = 0; activo = false; });
    });
  }
}
